module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    attrs: {
      "id": "nav-container"
    }
  }, [_c('nav', {
    staticClass: "wrap",
    attrs: {
      "id": "status"
    }
  }, [_c('a', {
    staticClass: "actif",
    attrs: {
      "href": "javascript: void 0",
      "id": "goto-start"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeSection', 'start')
      }
    }
  }, [_c('i', {
    staticClass: "icon-valid"
  }), _vm._v("\n      NATURE\n    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript: void 0",
      "id": "goto-intervention"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeSection', 'intervention')
      }
    }
  }, [_c('i', {
    staticClass: "icon-valid"
  }), _vm._v("\n      INTERVENTION\n    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript: void 0",
      "id": "goto-finish"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeSection', 'finish')
      }
    }
  }, [_c('i', {
    staticClass: "icon-valid"
  }), _vm._v("\n      SIGNATURE\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6bb1294","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/Nav.vue
// module id = 794
// module chunks = 0